import { CheckboxProps, Checkbox as MUICheckbox, styled } from '@mui/material';
import { CheckBoxIcon, RecgtangleIcon } from '../icons';
import { memo } from 'react';

const StyledCheckbox = styled(MUICheckbox)(({ theme: { palette } }) => ({
	padding: '0rem',
	color: palette.theme?.secondary[300],
	borderRadius: '.625rem',
	'&.Mui-checked': {
		color: palette.theme?.primary[600],
		'&:hover': {
			color: palette.theme?.primary[500]
		}
	},
	'&.Mui-disabled': {
		color: palette.theme?.secondary[400]
	}
}));

const Checkbox = memo((props: CheckboxProps) => {
	return (
		<StyledCheckbox
			icon={<RecgtangleIcon fontSize={props?.size || 'small'} />}
			checkedIcon={<CheckBoxIcon fontSize={props?.size || 'small'} />}
			disableRipple
			{...props}
		/>
	);
});

export { Checkbox };
export default Checkbox;
